import { Box, IconButton } from '@mui/material';

import ArrowIcon from 'app/assets/icons/arrow.svg?react';

export default function VerticalRearrangeArrows({
  onMoveUp,
  onMoveDown,
  moveUpDisabled,
  moveDownDisabled,
}) {
  return (
    <Box className="flex flex-col gap-8">
      <IconButton
        className="p-0"
        disabled={moveUpDisabled || !onMoveUp}
        onClick={onMoveUp}
        aria-label="Move up"
        title="Move up"
      >
        <ArrowIcon className="h-16 w-16" />
      </IconButton>
      <IconButton
        className="p-0"
        disabled={moveDownDisabled || !onMoveDown}
        onClick={onMoveDown}
        aria-label="Move down"
        title="Move down"
      >
        <ArrowIcon className="rotate-180 h-16 w-16" />
      </IconButton>
    </Box>
  );
}
